import { render, staticRenderFns } from "./PendingSurveysCard.vue?vue&type=template&id=79d63e0a&scoped=true"
import script from "./PendingSurveysCard.vue?vue&type=script&lang=js"
export * from "./PendingSurveysCard.vue?vue&type=script&lang=js"
import style0 from "./PendingSurveysCard.vue?vue&type=style&index=0&id=79d63e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d63e0a",
  null
  
)

export default component.exports